export class UserPermissions {
  isActive: boolean;
  isEmployerStaff: boolean;
  isStaff: boolean;

  constructor(data: UserPermissions | DjangoUserPermissions = {}) {
    if (data instanceof UserPermissions) {
      bindUserPermissionsDat(this, data);
    } else {
      bindDjangoUserPermissionsDat(this, data);
    }
  }

  get djangoModel() {
    return getDjangoModel(this);
  }
}

export function parseUserPermissions(data: DjangoUserPermissions | UserPermissions) {
  if (data) {
    return new UserPermissions(data);
  } else {
    return undefined;
  }
}

function bindUserPermissionsDat(userPermissions: UserPermissions, data: UserPermissions) {
  userPermissions.isActive = data.isActive;
  userPermissions.isEmployerStaff = data.isEmployerStaff;
  userPermissions.isStaff = data.isStaff;
}

//////////////////////
/// DJANGO SUPPORT ///
//////////////////////
export interface DjangoUserPermissions {
  is_active?: boolean;
  is_employer_staff?: boolean;
  is_staff?: boolean;
}

function bindDjangoUserPermissionsDat(
  userPermissions: UserPermissions,
  data: DjangoUserPermissions,
) {
  userPermissions.isActive = data.is_active;
  userPermissions.isEmployerStaff = data.is_employer_staff;
  userPermissions.isStaff = data.is_staff;
}

function getDjangoModel(userPermissions: UserPermissions) {
  return {
    is_active: userPermissions.isActive,
    is_employer_staff: userPermissions.isEmployerStaff,
    is_staff: userPermissions.isStaff,
  };
}
